import React from "react";
import { Booking } from "../events/Interface";
import { RiCircleFill } from "react-icons/ri";
import { format, isToday, isTomorrow, parseISO } from "date-fns";
import clockIcon from "../../assets/icons/clockIcon.svg";
import userIcon from "../../assets/icons/userIcon.svg";

import { toZonedTime } from "date-fns-tz";
import { getTimeDifference } from "@thdinc/hpf-shared";
import { timeToAmPm } from "@/helpers/TimeFormat";
interface BookingCardInterface {
  booking: Booking;
}

const roundUpPrice = (price: number) => {
  const decimalPlaces = 0;
  const factor = Math.pow(10, decimalPlaces);
  const roundedUp = Math.ceil(price * factor) / factor;
  return roundedUp;
};
export const BookingCard: React.FC<BookingCardInterface> = ({ booking }) => {
  const {
    first_name,
    last_name,
    discount_total,
    producttotal,
    service_total,
    auto_selected,
    start_time,
    end_time,
    timezone,
    bartenders,
    guests,
    packagetype
  } = booking;
  return (
    <div className="p-3 rounded-xl bg-p-gray cursor-pointer">
      <div className="flex justify-between items-center">
        <h2 className="text-lg font-semibold">
          {first_name + " " + last_name}
        </h2>
        {
          isToday(parseISO(start_time)) ? (
            <p className="bg-[#6DC488] text-white text-xs px-3 py-1 rounded-full">
              Today
            </p>
          ) : isTomorrow(parseISO(start_time)) ? (
            <p className="bg-[#EB8541] text-white text-xs px-3 py-1 rounded-full">
              Tomorrow
            </p>
          ) : (
            ""
          )
          // <p className="text-xs">{format(parseISO(start_time), "MM-dd-yyyy")}</p>
        }
      </div>
      {packagetype ==='custom_package' && (
        <p className="text-gray-400 text-[10px] font-bold flex items-center gap-1 my-1">
         
          Custom Package
        </p>
      ) }
       {packagetype ==='standard' && (
        <p className="text-gray-400 text-[10px] font-bold flex items-center gap-1 my-1">
         
          Standard
        </p>
      ) }
      {/* {auto_selected ? (
        <p className="text-[#FF6100] text-[10px] font-bold flex items-center gap-1 my-1">
          <RiCircleFill />
          Unassinged
        </p>
      ) : (
        <p className="text-[#00B69B] text-[10px] font-bold flex items-center gap-1 my-1">
          <RiCircleFill />
          Assinged
        </p>
      )} */}
      <p className=" text-sm text-gray-500">
        {" "}
        {start_time && format(parseISO(start_time), "PPPP")}
      </p>
      <p className="text-primary-red text-xs font-semibold ">
        {timeToAmPm(start_time, timezone) +
          " To " +
          timeToAmPm(end_time, timezone)}
      </p>
      <div className="flex justify-between  flex-wrap gap-2 items-baseline mt-2 ">
        <div className="flex items-center justify-start gap-5 ">
          <div className="bg-white px-4 py-1 flex gap-2 items-center rounded-full">
            {/* <BsClock size={14} /> */}
            <img src={clockIcon} />
            <p className="text-sm font-semibold">
              {
                getTimeDifference(
                  format(toZonedTime(start_time, timezone), "HH:mm"),
                  format(toZonedTime(end_time, timezone), "HH:mm")
                ).hours
              }{" "}
              <span className="text-xs">hrs</span>{" "}
            </p>
          </div>
          <div className="bg-white px-4 py-1 flex gap-2 items-center rounded-full">
            {/* <LiaUser size={17} /> */}
            <img src={userIcon} />
            <p className="text-sm font-semibold">{guests}</p>
          </div>
        </div>
        <div className="relaive flex px-2">
          {bartenders.length > 1 ? (
            bartenders.map((br, index) => {
              return (
                <img
                  key={index}
                  className="rounded-full object-cover w-8 h-8 -ml-3 border-2"
                  src={br.avatar}
                />
              );
            })
          ) : (
            <img
              className="rounded-full object-cover w-8 h-8 "
              src={bartenders[0]?.avatar}
            />
          )}
        </div>
      </div>
    </div>
  );
};
